import styles from "./button.module.css";
import { Button, IconButton, IconButtonProps, SvgIcon } from "@mui/material";
import { ButtonProps } from "@mui/material/Button/Button";
import { ForwardedRef, forwardRef } from "react";

export type HoverFillButtonVariant = "close" | "delete" | "normal";

type CustomButtonProps = Omit<ButtonProps, "variant" | "className">;

export type HoverFillButtonProps = {
	variant?: HoverFillButtonVariant;
} & CustomButtonProps;

export const HoverFillButton = forwardRef(function HoverFillButton(
	{ variant = "normal", children, ...buttonProps }: HoverFillButtonProps,
	ref: ForwardedRef<HTMLButtonElement>,
) {
	return (
		<Button {...buttonProps} variant="outlined" className={`${styles.hoverFillButton} ${styles[variant]}`} ref={ref}>
			{children}
		</Button>
	);
});

export const HoverGrowIconButton = forwardRef(function HoverGrowIconButton(
	{ children, size, ...buttonProps }: Omit<IconButtonProps, "variant" | "className">,
	ref: ForwardedRef<HTMLButtonElement>,
) {
	return (
		<IconButton {...buttonProps} size={size} className={styles.hoverGrowIconButton} disableRipple ref={ref}>
			<SvgIcon fontSize={size}>{children}</SvgIcon>
		</IconButton>
	);
});
